export default __webpack_public_path__ + "static/media/feature-layout.290a0d74.webp";